import { CrisisResources } from '../components/CrisisResources';

/**
 * Terminal screen for a historic user whose age verification status
 * is rejected_minor. The new community-attestation model doesn't
 * create new rows of this kind, but pre-existing accounts persist —
 * so this page still ships. Tone: warm, not cold. The rejection is
 * about LessAlone's adults-only scope, not a judgment on the person.
 */
export function Rejected() {
  return (
    <main>
      <div className="card rejected">
        <p className="step-label">A note from us</p>
        <h1>We can't be your place yet.</h1>
        <p>
          LessAlone is for adults 18 and older — that's a hard line we hold so the people who do
          sign up trust who they're talking with. When you turn 18, you'll be welcome here.
        </p>
        <p>
          In the meantime, if something is hard right now, you don't have to wait on anyone. These
          lines are good people, free, and open any hour:
        </p>
        <div className="crisis crisis-soft">
          <CrisisResources />
        </div>
        <p className="muted rejected-coda">
          You're worth talking to. Please reach out to one of the lines above if today is heavy.
        </p>
      </div>
    </main>
  );
}
